import { SimpleMuiButton } from '@dreamstack/feature-components/src/layout/SimpleMuiButton'
import { useTranslation } from '@dreamstack/i18n'
import { Download } from '@dreamstack/icons/src/icon-components/Download'
import { Pdf } from '@dreamstack/icons/src/icon-components/Pdf'
import { Media } from '@dreamstack/payload/src/payload-types'
import Image from 'next/image'
import type { FunctionComponent } from 'react'

export const EmbeddedAsset: FunctionComponent<
  React.PropsWithChildren<{
    asset: Media
  }>
> = ({ asset }) => {
  const t = useTranslation()
  const { title, url, height, width, alt, mimeType } = asset
  const containsPdf = mimeType?.match('pdf')
  const containsImg = mimeType?.match('image')

  if (containsPdf) {
    return (
      <a href={url ?? '#'} target="_blank" rel="noreferrer">
        <SimpleMuiButton
          variant={'text'}
          color={'secondary'}
          startIcon={<Pdf className="text-accentroGray-full" />}
        >
          {t('accentro:embeddedAsset.PDF')}
        </SimpleMuiButton>
      </a>
    )
  } else if (containsImg)
    return (
      <div>
        <Image
          className="mt-0 mb-0"
          src={url ?? ''}
          alt={alt ?? 'no alt'}
          height={height ?? 0}
          width={width ?? 0}
          title={title ?? ''}
        />
      </div>
    )
  else {
    return (
      <a href={url ?? '#'} target="_blank" rel="noreferrer">
        <SimpleMuiButton
          variant={'text'}
          color={'secondary'}
          startIcon={<Download className="text-accentroGray-full" />}
        >
          {t('accentro:embeddedAsset.documentDownload')}
        </SimpleMuiButton>
      </a>
    )
  }
}
